import { RsValue } from '../models/base/BaseModel';
import { LoginRequest, LoginResponse } from '../models/user/UserModels';
import { ForgotPasswordRequest, ResetPasswordRequest } from '../store/auth-store/UserModels';
import api from './axios';

export const authService = {
  login: (data: LoginRequest): Promise<RsValue<LoginResponse>> => api.post('/Auth/login', data),

  forgotPassword: (data: ForgotPasswordRequest): Promise<RsValue<string>> =>
    api.post('/User/forgot-password', data),

  resetPassword: (data: ResetPasswordRequest): Promise<RsValue<string>> =>
    api.post('/User/reset-password', data),
};
